import { render } from "./EnvioInfo.vue?vue&type=template&id=077e108b"
import script from "./EnvioInfo.vue?vue&type=script&lang=js"
export * from "./EnvioInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__